import React from 'react';
import { RECOMMENDATIONS } from '../data/constants';
import songs from '../data/songs';
import './MusicDiscovery.css';

export default function MusicDiscovery({ onPlaySong }) {
  const allArtists = [...new Set(songs.map(s => s.artist))];
  const [selectedArtist, setSelectedArtist] = React.useState(null);

  const recommendations = selectedArtist ? RECOMMENDATIONS[selectedArtist] || [] : [];

  const trendingSongs = songs
    .filter(s => s.year >= 2020)
    .sort(() => Math.random() - 0.5)
    .slice(0, 6);

  const globalTopSongs = [...songs]
    .sort(() => Math.random() - 0.5)
    .slice(0, 6);

  return (
    <div className="music-discovery">
      <h3>🔍 音乐发现</h3>

      <div className="discovery-section">
        <h4>🔥 热门趋势</h4>
        <div className="discovery-grid">
          {trendingSongs.map(song => (
            <div key={song.id} className="discovery-card" onClick={() => onPlaySong(song)}>
              <img src={song.cover} alt={song.album} />
              <div className="discovery-info">
                <p className="discovery-title">{song.title}</p>
                <p className="discovery-artist">{song.artist}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="discovery-section">
        <h4>🌍 全球 Top 50</h4>
        <div className="discovery-grid">
          {globalTopSongs.map((song, idx) => (
            <div key={song.id} className="discovery-card" onClick={() => onPlaySong(song)}>
              <span className="rank">#{idx + 1}</span>
              <img src={song.cover} alt={song.album} />
              <div className="discovery-info">
                <p className="discovery-title">{song.title}</p>
                <p className="discovery-artist">{song.artist}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="discovery-section">
        <h4>🎤 相似艺术家推荐</h4>
        <div className="artist-select">
          <select value={selectedArtist || ''} onChange={e => setSelectedArtist(e.target.value || null)}>
            <option value="">选择一位艺术家...</option>
            {Object.keys(RECOMMENDATIONS).map(artist => (
              <option key={artist} value={artist}>{artist}</option>
            ))}
          </select>
        </div>
        {selectedArtist && recommendations.length > 0 && (
          <div className="recommendations">
            <p className="rec-intro">如果你喜欢 <strong>{selectedArtist}</strong>，试试：</p>
            <div className="rec-artists">
              {recommendations.map(rec => (
                <span key={rec} className="rec-artist">{rec}</span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
